import React from 'react';

import {ScoreboardWidgetProps} from "../models/scoreboard-widget.props";
import {ScoreboardWidgetController} from "../scoreboard-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {ScoreboardWidgetHeadersTableRow} from "./scoreboard-widget.headers-table-row";
import {ScoreboardWidgetCompetitorTableRow} from "./scoreboard-widget.competitor-table-row";
import {Table} from "../../../core/components/table/table";
import {ScoreboardWidgetMatchTimeTableRow} from "./scoreboard-widget.match-time-table-row";
import {ScoreboardWidgetDivider} from "./scoreboard-widget.divider";

export class ScoreboardWidgetComponentProps extends ScoreboardWidgetProps {}

export const ScoreboardWidgetComponent = (({controller}: ScoreboardWidgetComponentProps) => {
  const {state} = controller;
  const {device} = state;

  const gameCardWrapperProps = {
    controller,
    title: controller.state.terms.WEB_GAME_CENTER_SCOREBOARD,
  }

  const containerProps = {
    className: [(device.isSmallView ? 'scoreboard-widget-small-view' : ''), 'scoreboard-widget'].join(' '),
  }

  return (
    <WidgetWrapper {...gameCardWrapperProps}>
      <Table {...containerProps}>
        <ScoreboardWidgetHeadersTableRow stages={controller.state.stages}/>
        <ScoreboardWidgetCompetitorTableRow competitor={controller.state.homeCompetitor} isEven={true}/>
        <ScoreboardWidgetCompetitorTableRow competitor={controller.state.awayCompetitor}/>
        <ScoreboardWidgetDivider/>
        {
          controller.state.shouldRenderMatchTimeRow && <ScoreboardWidgetMatchTimeTableRow stages={controller.state.stages}/>
        }
      </Table>
    </WidgetWrapper>
  )
});

const settings: ComposeSettings = {
  component: ScoreboardWidgetComponent,
  propsType: ScoreboardWidgetComponentProps,
  controllerType: ScoreboardWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,


  observe: true,
}

export default Compose(settings);
